import React from "react";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    LinearScale,
    Title,
    Tooltip,
    Legend,
    CategoryScale,
    Filler,
} from "chart.js";

ChartJS.register(
    LineElement,
    PointElement,
    LinearScale,
    Title,
    Tooltip,
    Legend,
    CategoryScale,
    Filler
);

const LineChartWithPointWorkflow = (prop) => {
    //const data = {
    //    labels: ["02:00", "03:00", "04:00", "05:00", "06:00", "07:00"],
    //    datasets: [
    //        {
    //            label: "Actual Data",
    //            data: [
    //                100, 120, 150, 110, 140, 100
    //            ],
    //            borderColor: "#2BB219",
    //            backgroundColor: "#2BB21920",
    //            fill: true,
    //            tension: 0.4,
    //        },
    //    ],
    //};

    //const options = {
    //    responsive: true,
    //    maintainAspectRatio: false,
    //    plugins: {
    //        legend: {
    //            display: false,
    //        },
    //        tooltip: {
    //            display: true,
    //        },
    //    },
    //    scales: {
    //        x: {
    //            display: true,
    //            grid: {
    //                display: true,
    //                offset: false,
    //            },
    //            ticks: {
    //                align: 'center',
    //            },
    //        },
    //        y: {
    //            display: false,
    //            grid: {
    //                display: false,
    //            },
    //        },
    //    },
    //};

    return (
        prop.data && prop.options &&
        <Line data={prop.data} options={prop.options} />
    );
};

export default LineChartWithPointWorkflow;